require('./availability-form.scss')

module.exports = {
  template: require('./availability-form.pug')()
  controller: require('./availability-form.ctrl')
  bindings:
    services: '<'
    onSubmit: '&'
}
